import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { errorAlert } from '../../../helpers/alerts';
import { hasSameValues } from '../../../helpers/util';
import { updateEmailReportService } from '../../../services/report/emailReportService';
import { updateEmailReport } from '../../../redux/slices/report/emailReportSlice';
import EmailReportForm from '../../../components/report/EmailReportForm';
import { setLoading } from '../../../redux/slices/uiSlice';

const EditEmailReportScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentEmailReport: current } = useSelector((store) => store.emailReport);

  const values = {
    group: current?.group?.id || null,
    hoster: current?.hoster?.id || null,
    type: current?.type || '',
    range: current?.range || '',
    emails: current?.emails || [],
  }

  const handlerBack = () => {
    navigate("/reportes/correos");
  };

  const handlerSubmit = async (data) => {
    dispatch(setLoading(true))
    updateEmailReportService(current.id, data).then(() => {
      dispatch(updateEmailReport({ id: current.id, data }));
      navigate("/reportes/correos");
    }).catch((e) => errorAlert(e))
      .finally(() => dispatch(setLoading(false)))
  }

  const validate = (data) => !hasSameValues(values, data)
  return (
    <EmailReportForm
      title={"Reportes por Correo"}
      goBack={handlerBack}
      submit={handlerSubmit}
      validate={validate}
      defaultValues={values}
    />
  )
}

export default EditEmailReportScreen